import React, { useLayoutEffect, useRef, useState } from 'react'
import type { HTMLElementProps } from '~/types'
import { ImageSrc, imageUrl, ImageUrlDimensions, isImage } from '~/utils'

export type ImageProps = HTMLElementProps<
	'img',
	{
		src: ImageSrc
		dimensions?: 'full' | 'responsive' | ImageUrlDimensions
	}
>

export const Image: React.FC<ImageProps> = ({ src, loading = 'lazy', dimensions = 'responsive', ...props }) => {
	const ref = useRef<HTMLImageElement | null>(null)
	const [size, setSize] = useState<ImageUrlDimensions>()
	useLayoutEffect(() => {
		// Ref should never be null when using useLayoutEffect but we add check for type support
		if (ref.current === null) return
		const mult = 1.2 * window.devicePixelRatio
		const image = ref.current
		switch (dimensions) {
			case 'responsive':
				if (image.clientWidth > 30 && image.clientHeight > 30) {
					setSize({ height: image.clientHeight * mult, width: image.clientWidth * mult, crop: 'center' })
				} else {
					setSize(
						image.clientHeight > 30
							? { height: image.clientHeight * mult }
							: { width: image.clientWidth * mult }
					)
				}

				break

			case 'full':
				setSize({ width: window.innerWidth * mult })
				break

			default:
				setSize(dimensions)
				break
		}
	}, [dimensions])
	return <img src={imageUrl(src, size)} ref={ref} loading={loading} {...props} />
}

export type MediaProps = ImageProps

// TODO: Support more media types
export const Media: React.FC<MediaProps> = props => {
	if (isImage(props.src)) return <Image {...props} />
	else return null
}
